import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Style from './DataControlEntity.module.css';
import ScanRules from './ScanRules';
import ServiceEntities from './ServiceEntities';
import EntitiesAttributes from './EntitiesAttributes';
import Extensions from './Extensions';
import { getServiceEntities, getScanRules, getExtensionCatalogue } from '../../store/entities/dataControlEntity';

// The entity view is READ-ONLY: it displays the DB-seeded service entities and
// scan rules. Three tabs — Scan Rules, Service Entities, and Entities & Attributes
// (the per-entity attribute registry). Reachable by direct URL only (no menu entry).
const TABS = ['Scan Rules', 'Service Entities', 'Entities & Attributes', 'Extensions'];

const DataControlEntity = (props) => {
  const [tab, setTab] = useState(0);
  const { serviceEntities, scanRules } = props;

  useEffect(() => {
    props.getServiceEntities();
    props.getScanRules();
    props.getExtensionCatalogue();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const activeScanRules = (scanRules || []).filter((r) => r.isActive).length;
  const attributeCount = (serviceEntities || []).reduce((n, se) => n + ((se.attributes || []).length), 0);

  return (
    <div className={Style.page}>
      <div className={Style.tabBar}>
        {TABS.map((t, i) => (
          <button key={t} className={`${Style.tabBtn} ${i === tab ? Style.tabBtnActive : ''}`} onClick={() => setTab(i)}>
            {t}
          </button>
        ))}
      </div>

      <div className={Style.statRow3}>
        <div className={Style.statCard}>
          <div className={Style.statLabel}>Active Scan Rules</div>
          <div className={Style.statValue}>{activeScanRules}</div>
          <div className={Style.statNote}>Evaluated on every page</div>
        </div>
        <div className={Style.statCard}>
          <div className={Style.statLabel}>Service Entities</div>
          <div className={Style.statValue}>{(serviceEntities || []).length}</div>
          <div className={Style.statNote}>Reusable element templates</div>
        </div>
        <div className={Style.statCard}>
          <div className={Style.statLabel}>Observable Attributes</div>
          <div className={Style.statValue}>{attributeCount}</div>
          <div className={Style.statNote}>Across all service entities</div>
        </div>
      </div>

      {tab === 0 && <ScanRules />}
      {tab === 1 && <ServiceEntities />}
      {tab === 2 && <EntitiesAttributes />}
      {tab === 3 && <Extensions />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceEntities: state.entities.dataControlEntity.serviceEntities,
  scanRules: state.entities.dataControlEntity.scanRules,
});

const mapDispatchToProps = (dispatch) => ({
  getServiceEntities: () => dispatch(getServiceEntities()),
  getScanRules: () => dispatch(getScanRules()),
  getExtensionCatalogue: () => dispatch(getExtensionCatalogue()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataControlEntity));
